import { ReactComponent as NG_Acorn } from "./acorn.svg";
import Netgreen_Acorn from "./Netgreen_Acorn.png";
import NetgreenCapitalLogo from "./NetGreenCapitalLogo.png";
export { Netgreen_Acorn, NetgreenCapitalLogo, NG_Acorn };
